import {
	Checkbox,
	FormControlLabel,
	FormGroup,
	InputLabel,
	ToggleButton,
	ToggleButtonGroup,
} from "@mui/material";
import { PdfTemplateType } from "../../pdf-templates/document-template.types";

interface FontControlGroupProps {
	fontSizeValue: "sm" | "md" | "lg" | "xl" | "xxl" | undefined;
	fontSizeProperty: string;
	template: PdfTemplateType | "general";
	updatePdfTemplateConfiguration: (
		template: PdfTemplateType | "general",
		config: Record<string, any>
	) => Promise<boolean>;
}

export const FontControlGroup: React.FC<FontControlGroupProps> = ({
	fontSizeValue,
	fontSizeProperty,
	template,
	updatePdfTemplateConfiguration,
}) => {
	return (
		<>
			<div className="flex flex-col gap-2">
				<InputLabel>Schriftgröße</InputLabel>
				<ToggleButtonGroup
					color="primary"
					value={fontSizeValue || "lg"}
					exclusive
					onChange={(e, v) => {
						if (v !== null) {
							updatePdfTemplateConfiguration(template, {
								[fontSizeProperty]: v as "sm" | "md" | "lg" | "xl" | "xxl",
							});
						}
					}}
					aria-label="Font size"
				>
					<ToggleButton value="sm">sehr klein</ToggleButton>
					<ToggleButton value="md">klein</ToggleButton>
					<ToggleButton value="lg">mittel</ToggleButton>
					<ToggleButton value="xl">groß</ToggleButton>
					<ToggleButton value="xxl">sehr groß</ToggleButton>
				</ToggleButtonGroup>
			</div>
		</>
	);
};